"use client"

import { useMutation } from "@tanstack/react-query"
import { toast } from "sonner"

import { apiClient } from "@/lib/api/client"
import { apiUrl } from "@/lib/api/url"

import type { PublicMessageCreate } from "@/nango/types/apps.tsp/public_message/PublicMessage"

type Options = {
  onSuccess?: (data: { id: number }) => void
  successMessage?: string
}

function defaultErrorHandler(err: unknown) {
  const message = err instanceof Error ? err.message : "Une erreur est survenue"
  toast.error(message)
}

export function useCreateTspPublicMessage(options: Options = {}) {
  return useMutation({
    mutationFn: (data: PublicMessageCreate) =>
      apiClient<{ id: number }>({
        url: apiUrl("api/tsp/tsp_public_message/"),
        method: "POST",
        data,
      }),
    onSuccess: (data) => {
      if (options.successMessage) toast.success(options.successMessage)
      options.onSuccess?.(data)
    },
    onError: defaultErrorHandler,
  })
}
